import { ExportSection } from '../components/ExportsSettings/components'
import { ExportArbeidstilsynetCard } from '../components/ExportsSettings/export-arbeidstilsynet-card'

export function ExportArbeidstilsynet() {
  return (
    <ExportSection header="Eksport Arbeidstilsynet">
      <ExportArbeidstilsynetCard />
    </ExportSection>
  )
}
